import { DAY, MINUTE, type TaskData, type TaskListInput, type TaskListSuccess } from '@terros/common'
import { type GetHookResponse } from '../hooks'
import { useTantalimQuery } from '../query'
import { useTaskCache } from './cache'
import { taskListKey } from './keys'

export function useTasks(input?: TaskListInput): GetHookResponse<TaskData[]> {
  const cache = useTaskCache()
  return useTantalimQuery<TaskListInput, TaskListSuccess, TaskData[]>({
    url: '/task/list',
    queryKey: taskListKey(input),
    input: input ?? {},
    convertResponse: (data) => {
      const { tasks } = data
      tasks.forEach((t) => cache.setItem(t))
      return tasks
    },
    options: {
      gcTime: DAY,
      staleTime: 15 * MINUTE,
    },
  })
}
